import { useApiClient } from '@eluve/api-client-provider';
import { useNamedLogger } from '@eluve/logger';

export const useRegeneratePatientOverview = () => {
  const logger = useNamedLogger('useRegeneratePatientOverview');
  const apiClient = useApiClient();

  const regeneratePatientOverview = async (
    tenantId: string,
    appointmentId: string,
  ) => {
    const result = await apiClient.llm.regeneratePatientOverview({
      body: {},
      params: {
        tenantId,
        appointmentId,
      },
    });

    if (result.status !== 201) {
      const message = result.status === 422 ? result.body.message : undefined;
      throw new Error(
        message ?? 'Failed to schedule patient overview regeneration',
      );
    }

    logger.debug('Patient overview regeneration scheduled', {
      appointmentId,
    });
  };

  return regeneratePatientOverview;
};
